module.exports = __webpack_public_path__ + "img/submenu-bg.b3d13864.jpg";